<!--과정 버튼-->
<template>
  <button
    :id="id"
    :class="['footer_button', buttonClass]"
    :disabled="isDisabled"
    @click="handleClick"
    @mouseover="showTooltip = false"
    @mouseleave="showTooltip = false">
    {{ label }}
    <div v-if="showTooltip && tooltip" class="tooltip-view">{{ tooltip }}</div>
  </button>
</template>

<script>
import commonMixin from '@/mixin/commonMixin'
export default {
  name: 'ComCorsButton',
  // metaInfo () {
  //   return {
  //     title: '멀티캠퍼스 :: 과정 버튼 컴포넌트'
  //   }
  // },
  mixins: [commonMixin],
  props: {
    id: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    buttonClass: {
      type: String,
      default: ''
    },
    tooltip: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showTooltip: false
    }
  },
  methods: {
    handleClick () {
      this.$emit('click', this.id)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/nrw/common/ComCorsButton.vue